import { createSelector } from 'reselect';

const slice = ({ app }) => app;

export const configSelector = createSelector(
  slice,
  ({ siteConfig }) => siteConfig
);
export const currencySelector = createSelector(
  slice,
  ({ currency }) => currency
);

export const countriesSelector = createSelector(
  slice,
  ({ countries }) => countries.items
);

export const bikeTypesSelector = createSelector(
  slice,
  ({ bikeTypes }) => bikeTypes.items
);

export const extraItemTypesTypesSelector = createSelector(
  slice,
  ({ extraItemTypes }) => extraItemTypes.items
);

export const popularDestinationsSelector = createSelector(
  slice,
  ({ popularDestinations }) => popularDestinations.items
);



// WEBPACK FOOTER //
// ./src/selectors/app.js